import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Text,
} from '@shared/ui';

export function DropdownMenuShowcase() {
  const { t } = useTranslation();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.overlay.dropdown.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.overlay.dropdown.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" className="w-full sm:w-auto">
                {t('uiLibrary.overlay.dropdown.trigger')}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start">
              <DropdownMenuItem>{t('uiLibrary.overlay.dropdown.items.profile')}</DropdownMenuItem>
              <DropdownMenuItem>{t('uiLibrary.overlay.dropdown.items.settings')}</DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem>{t('uiLibrary.overlay.dropdown.items.signOut')}</DropdownMenuItem>
              <DropdownMenuItem variant="destructive">
                {t('uiLibrary.overlay.dropdown.items.delete')}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <Text size="sm" color="muted" className="w-full sm:w-auto">
            {t('uiLibrary.overlay.dropdown.helper')}
          </Text>
        </div>
      </CardContent>
    </Card>
  );
}
